export const vpuigrd = () => {
    const uiGridBreakpoint = getComputedStyle(document.documentElement)
        .getPropertyValue('--ui-grid-breakpoint')
        .trim();
    return !!(window.matchMedia(`(max-width: ${uiGridBreakpoint})`).matches);
};
